import React, { Component } from 'react';


class Results extends Component {
    render() {
        
        const { item, miniView} = this.props;

        return (
                <div data-id={item.id} className="col-xl-2 col-lg-2 col-md-3 col-sm-6 animated fadeInDown"
                    data-mode = {item.mode}
                    data-name = {item.biz_name}
                    onClick={()=> item.is_active === true ?  miniView(item): ''}>
                    {/*Result*/}
                    <div className={item.is_active === true ? "text-center ecosystem card zoom-element aggSelect" : "text-center card opac-5 ecosystem"}
                    >
                        <div className="body text-center" title={item.biz_name}>
                            <h4 className="m-t-0 m-b-1">{item.biz_name}</h4>
                            <i className="fa fa-building" />
                            {/* <img className="adv-clients" src={"/assets/clients/" + item.img} alt={item.name}/> */}
                        </div>
                    </div>
                </div>

        );
    }
}

export default Results;
